// Imports
import ___CSS_LOADER_API_SOURCEMAP_IMPORT___ from "../../../../node_modules/css-loader/dist/runtime/sourceMaps.js";
import ___CSS_LOADER_API_IMPORT___ from "../../../../node_modules/css-loader/dist/runtime/api.js";
var ___CSS_LOADER_EXPORT___ = ___CSS_LOADER_API_IMPORT___(___CSS_LOADER_API_SOURCEMAP_IMPORT___);
// Module
___CSS_LOADER_EXPORT___.push([module.id, `.import-container {
  background-color: #fefefe;
  padding: 20px;
  border-radius: 8px;
  box-shadow: 0 2px 4px rgba(0, 0, 0, 0.1);
  /* width: 80%; */
  /* max-width: 600px; */
}

.file-upload-header {
  display: flex;
  flex-direction: column;
  justify-content: space-between;
  align-items: flex-start;
  gap: 10px;
  margin-bottom: 15px;
  padding-bottom: 10px;
  border-bottom: 1px solid #eee;
}

.file-upload-header h2 {
  margin: 0;
  font-size: 1.5rem;
  color: #333;
}

.file-upload-header .close-button {
  background: none;
  border: none;
  font-size: 1.5rem;
  cursor: pointer;
  color: #777;
}

.checklist-section {
  background-color: #fff8dc; /* Light yellow background */
  border: 1px solid #eee;
  padding: 15px;
  border-radius: 4px;
  margin-bottom: 15px;
}

.checklist-section h3 {
  margin-top: 0;
  color: #555;
  font-size: 1.1rem;
}

.checklist-section h4 {
  margin-top: 10px;
  color: #555;
  font-size: 1rem;
}

.checklist-section ul {
  padding-left: 20px;
  margin-bottom: 10px;
  color: #666;
  font-size: 0.9rem;
}

.checklist-section li {
  margin-bottom: 5px;
}

.checklist-section a {
  color: #007bff;
  text-decoration: none;
}

.import-file-section {
  margin-bottom: 20px;
}

.import-file-section label {
  display: block;
  margin-bottom: 5px;
  color: #333;
  font-weight: bold;
}

.import-file-section .file-input-wrapper {
  display: flex;
  align-items: center;
}

.import-file-section .choose-file-button {
  background-color: #f0f0f0;
  color: #333;
  border: 1px solid #ccc;
  padding: 8px 12px;
  border-radius: 4px;
  cursor: pointer;
  font-size: 0.9rem;
  margin-right: 10px;
}

.import-file-section .file-name {
  color: #777;
  font-size: 0.9rem;
}

.import-file-section .file-input {
  display: none; /* Hide the default file input */
}

.import-button-section {
  text-align: left;
}

.import-button-section .import-button {
  background-color: #4caf50;
  color: white;
  padding: 10px 15px;
  border: none;
  border-radius: 4px;
  cursor: pointer;
  font-size: 1rem;
}

.import-button-section .import-button:hover {
  background-color: #45a049;
}

.error-message {
  color: red;
  font-size: 0.9rem;
  margin-top: 5px;
}
`, "",{"version":3,"sources":["webpack://./src/components/ComponentsCss/HolidaysComponent/GeneralImport.css"],"names":[],"mappings":"AAAA;EACE,yBAAyB;EACzB,aAAa;EACb,kBAAkB;EAClB,wCAAwC;EACxC,gBAAgB;EAChB,sBAAsB;AACxB;;AAEA;EACE,aAAa;EACb,sBAAsB;EACtB,8BAA8B;EAC9B,uBAAuB;EACvB,SAAS;EACT,mBAAmB;EACnB,oBAAoB;EACpB,6BAA6B;AAC/B;;AAEA;EACE,SAAS;EACT,iBAAiB;EACjB,WAAW;AACb;;AAEA;EACE,gBAAgB;EAChB,YAAY;EACZ,iBAAiB;EACjB,eAAe;EACf,WAAW;AACb;;AAEA;EACE,yBAAyB,EAAE,4BAA4B;EACvD,sBAAsB;EACtB,aAAa;EACb,kBAAkB;EAClB,mBAAmB;AACrB;;AAEA;EACE,aAAa;EACb,WAAW;EACX,iBAAiB;AACnB;;AAEA;EACE,gBAAgB;EAChB,WAAW;EACX,eAAe;AACjB;;AAEA;EACE,kBAAkB;EAClB,mBAAmB;EACnB,WAAW;EACX,iBAAiB;AACnB;;AAEA;EACE,kBAAkB;AACpB;;AAEA;EACE,cAAc;EACd,qBAAqB;AACvB;;AAEA;EACE,mBAAmB;AACrB;;AAEA;EACE,cAAc;EACd,kBAAkB;EAClB,WAAW;EACX,iBAAiB;AACnB;;AAEA;EACE,aAAa;EACb,mBAAmB;AACrB;;AAEA;EACE,yBAAyB;EACzB,WAAW;EACX,sBAAsB;EACtB,iBAAiB;EACjB,kBAAkB;EAClB,eAAe;EACf,iBAAiB;EACjB,kBAAkB;AACpB;;AAEA;EACE,WAAW;EACX,iBAAiB;AACnB;;AAEA;EACE,aAAa,EAAE,gCAAgC;AACjD;;AAEA;EACE,gBAAgB;AAClB;;AAEA;EACE,yBAAyB;EACzB,YAAY;EACZ,kBAAkB;EAClB,YAAY;EACZ,kBAAkB;EAClB,eAAe;EACf,eAAe;AACjB;;AAEA;EACE,yBAAyB;AAC3B;;AAEA;EACE,UAAU;EACV,iBAAiB;EACjB,eAAe;AACjB","sourcesContent":[".import-container {\n  background-color: #fefefe;\n  padding: 20px;\n  border-radius: 8px;\n  box-shadow: 0 2px 4px rgba(0, 0, 0, 0.1);\n  /* width: 80%; */\n  /* max-width: 600px; */\n}\n\n.file-upload-header {\n  display: flex;\n  flex-direction: column;\n  justify-content: space-between;\n  align-items: flex-start;\n  gap: 10px;\n  margin-bottom: 15px;\n  padding-bottom: 10px;\n  border-bottom: 1px solid #eee;\n}\n\n.file-upload-header h2 {\n  margin: 0;\n  font-size: 1.5rem;\n  color: #333;\n}\n\n.file-upload-header .close-button {\n  background: none;\n  border: none;\n  font-size: 1.5rem;\n  cursor: pointer;\n  color: #777;\n}\n\n.checklist-section {\n  background-color: #fff8dc; /* Light yellow background */\n  border: 1px solid #eee;\n  padding: 15px;\n  border-radius: 4px;\n  margin-bottom: 15px;\n}\n\n.checklist-section h3 {\n  margin-top: 0;\n  color: #555;\n  font-size: 1.1rem;\n}\n\n.checklist-section h4 {\n  margin-top: 10px;\n  color: #555;\n  font-size: 1rem;\n}\n\n.checklist-section ul {\n  padding-left: 20px;\n  margin-bottom: 10px;\n  color: #666;\n  font-size: 0.9rem;\n}\n\n.checklist-section li {\n  margin-bottom: 5px;\n}\n\n.checklist-section a {\n  color: #007bff;\n  text-decoration: none;\n}\n\n.import-file-section {\n  margin-bottom: 20px;\n}\n\n.import-file-section label {\n  display: block;\n  margin-bottom: 5px;\n  color: #333;\n  font-weight: bold;\n}\n\n.import-file-section .file-input-wrapper {\n  display: flex;\n  align-items: center;\n}\n\n.import-file-section .choose-file-button {\n  background-color: #f0f0f0;\n  color: #333;\n  border: 1px solid #ccc;\n  padding: 8px 12px;\n  border-radius: 4px;\n  cursor: pointer;\n  font-size: 0.9rem;\n  margin-right: 10px;\n}\n\n.import-file-section .file-name {\n  color: #777;\n  font-size: 0.9rem;\n}\n\n.import-file-section .file-input {\n  display: none; /* Hide the default file input */\n}\n\n.import-button-section {\n  text-align: left;\n}\n\n.import-button-section .import-button {\n  background-color: #4caf50;\n  color: white;\n  padding: 10px 15px;\n  border: none;\n  border-radius: 4px;\n  cursor: pointer;\n  font-size: 1rem;\n}\n\n.import-button-section .import-button:hover {\n  background-color: #45a049;\n}\n\n.error-message {\n  color: red;\n  font-size: 0.9rem;\n  margin-top: 5px;\n}\n"],"sourceRoot":""}]);
// Exports
___CSS_LOADER_EXPORT___.locals = {};
export default ___CSS_LOADER_EXPORT___;
